// Vendor imports
const qs = require('qs')
// Client lib imports
const businessEvents = require('client/lib/business-events')
// Client V2 common imports
const commonClient = require('client-v2/common/client')
// Entry imports
const configureStore = require('client-v2/logged-out-landing/state/store')
const rootFactory = require('client-v2/logged-out-landing/components/root').factory
// Sibling imports
const authSectionActions = require('./containers/auth-section/actions')
const loggedOutBannerActions = require('./containers/banner-section/actions')

commonClient.runAfterPageIsLoaded(() => {

  const { store } = commonClient.render(configureStore, rootFactory)

  commonClient.configureSession(store, {
    pageName: 'stream.profile'
  })

  businessEvents.trackSegment('pageview')

  const initialState = store.getState()
  const { pathname, search } = initialState.router.location
  const queryParams = qs.parse(search, { ignoreQueryPrefix: true })
  if (pathname === '/add' || pathname === '/mixit') {
    // Handle `/add` and `/mixit` modal route behaviors
    const url = queryParams.url || queryParams.source
    if (url) {
      store.dispatch(loggedOutBannerActions.show(url))
    }
  }

  store.dispatch(authSectionActions.maybeShowErrorAlert(queryParams))
})
